import {Component, OnInit} from "@angular/core";

@Component({
  selector: "app-pdf-export",
  templateUrl: "./pdf-export.component.html",
  styles: [],
})
export class PdfExportComponent {
}
